import SectionHeader from "./SectionHeader";
import Reveal from "./Reveal";
import { ExternalLink } from "lucide-react";

// Authoritative, independent sources on bed bugs. Outbound links to credible
// reference material signal topical relevance and place the site within the
// helpful-information ecosystem.
const RESOURCES = [
  {
    source: "Government of Canada",
    title: "Bed Bugs — Health Canada",
    url: "https://www.canada.ca/en/health-canada/services/pest-control-tips/bed-bugs.html",
    desc: "Official Canadian guidance on bed bug biology, prevention and the safe use of pest control products.",
  },
  {
    source: "U.S. Environmental Protection Agency",
    title: "Bed Bugs — EPA",
    url: "https://www.epa.gov/bedbugs",
    desc: "Evidence-based information on identifying, preventing and eliminating bed bug infestations.",
  },
  {
    source: "National Pest Management Association",
    title: "All Things Bed Bugs — PestWorld",
    url: "https://www.pestworld.org/all-things-bed-bugs/",
    desc: "Trade-association resources on bed bug behaviour, signs of infestation and professional treatment.",
  },
];

export default function Resources() {
  return (
    <section className="border-t border-border bg-background px-5 py-24 lg:px-8 lg:py-28">
      <div className="mx-auto max-w-7xl">
        <SectionHeader kicker="Resources" title="TRUSTED, AUTHORITATIVE REFERENCES." subtitle="Independent, evidence-based sources we draw on for our bed bug treatment guidance." />
        <div className="mt-14 grid gap-4 md:grid-cols-3">
          {RESOURCES.map((r, i) => (
            <Reveal key={r.url} delay={(i % 3) * 0.05}>
              <a href={r.url} target="_blank" rel="noopener noreferrer" className="group flex h-full flex-col rounded-lg border border-border bg-muted/20 p-7 transition-colors hover:border-accent/40 hover:bg-muted/40">
                <span className="text-[11px] font-semibold uppercase tracking-[0.18em] text-accent">{r.source}</span>
                <h3 className="mt-4 font-heading text-lg font-bold leading-snug text-primary">{r.title}</h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-muted-foreground">{r.desc}</p>
                <span className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-primary">Visit <ExternalLink className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" /></span>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}